























import { Component } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import {
  AlertMessage,
  bibliographySetApi,
  BibliographySetDetailAutoOrder,
  ErrorMessage
} from '@/api'
import { ChildCollectionListTable } from '@/components/organisms/ChildCollectionListTable'
import {
  AutoOrderEditInputs,
  AutoOrderEditInputsItem,
  defaultAutoOrderEditInputsItem
} from '@/components/organisms/AutoOrderEditInputs'
import { BibliographySetInfo } from '@/components/organisms/BibliographySetInfo'
import { setErrorMessage } from '@/utils/error'

interface ModalAutoOrderEditInterface {
  bibliographyId: number
  autoOrder: BibliographySetDetailAutoOrder
  onUpdated: () => void
}

@Component({
  components: {
    BibliographySetInfo,
    AutoOrderEditInputs,
    ChildCollectionListTable,
    ModalFooter
  }
})
export default class ModalAutoOrderEdit extends ComponentVue {
  dialog: boolean = false

  bibliographyId: number = 0

  inputs: AutoOrderEditInputsItem = defaultAutoOrderEditInputsItem()

  updatedCallback = () => {}

  get isEdit(): boolean {
    return !!this.inputs.orderAutoId
  }

  get title(): string {
    return '自動発注情報の' + (this.isEdit ? '編集' : '登録')
  }

  open(params: ModalAutoOrderEditInterface): void {
    this.bibliographyId = params.bibliographyId
    this.inputs = {
      orderAutoId: params.autoOrder.id,
      orderBranchCode: params.autoOrder.orderBranchCode,
      orderNumber: {
        input: String(params.autoOrder.orderNumber),
        errorMessage: ''
      },
      traderCode: {
        input: params.autoOrder.traderCode.code,
        display: params.autoOrder.traderCode.shortName,
        errorMessage: ''
      },
      acceptType: {
        input: params.autoOrder.acceptType.code,
        display: params.autoOrder.acceptType.shortName,
        errorMessage: ''
      },
      buyDepartmentCode: {
        input: params.autoOrder.buyDepartmentCode.code,
        display: params.autoOrder.buyDepartmentCode.shortName,
        errorMessage: ''
      },
      donatedNumber: {
        input: String(params.autoOrder.donatedNumber),
        errorMessage: ''
      },
      donorCode: {
        input: params.autoOrder.donorCode.code,
        display: params.autoOrder.donorCode.shortName,
        errorMessage: ''
      },
      budgetYear: {
        input: String(params.autoOrder.budgetYear || ''),
        errorMessage: ''
      },
      budgetBranchCode: {
        input: params.autoOrder.budgetBranchCode.code,
        display: params.autoOrder.budgetBranchCode.shortName,
        errorMessage: ''
      },
      budgetDepartmentCode: {
        input: params.autoOrder.budgetDepartmentCode.code,
        display: params.autoOrder.budgetDepartmentCode.shortName,
        errorMessage: ''
      },
      budgetItem: {
        input: params.autoOrder.budgetItem.code,
        display: params.autoOrder.budgetItem.shortName,
        errorMessage: ''
      },
      equipType: {
        input: params.autoOrder.equipType.code,
        display: params.autoOrder.equipType.shortName,
        errorMessage: ''
      },
      collectionType: {
        input: params.autoOrder.collectionType.code,
        display: params.autoOrder.collectionType.shortName,
        errorMessage: ''
      },
      shelfType: {
        input: params.autoOrder.shelfType.code,
        display: params.autoOrder.shelfType.shortName,
        errorMessage: ''
      },
      handlingType: {
        input: params.autoOrder.handlingType.code,
        display: params.autoOrder.handlingType.shortName,
        errorMessage: ''
      },
      storeType: {
        input: params.autoOrder.storeType.code,
        display: params.autoOrder.storeType.shortName,
        errorMessage: ''
      },
      storingLimitCode: {
        input: params.autoOrder.storingLimitCode.code,
        display: params.autoOrder.storingLimitCode.shortName,
        errorMessage: ''
      },
      mark: {
        input: params.autoOrder.mark,
        errorMessage: ''
      },
      ndc: {
        input: params.autoOrder.ndc,
        errorMessage: ''
      },
      book: {
        input: params.autoOrder.book,
        errorMessage: ''
      },
      sub: {
        input: params.autoOrder.sub,
        errorMessage: ''
      },
      revision: params.autoOrder.revision
    }
    this.updatedCallback = params.onUpdated
    this.dialog = true
  }

  close(): void {
    this.dialog = false
    this.bibliographyId = 0
    this.inputs = defaultAutoOrderEditInputsItem()
    this.updatedCallback = () => {}
  }

  async update(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await bibliographySetApi.updateAutoOrderInfo({
        id: this.bibliographyId,
        autoOrders: [
          {
            orderBranchCode: this.inputs.orderBranchCode.code,
            orderNumber: !isNaN(Number(this.inputs.orderNumber.input))
              ? Number(this.inputs.orderNumber.input)
              : 0,
            traderCode: this.inputs.traderCode.input,
            acceptType: this.inputs.acceptType.input,
            buyDepartmentCode: this.inputs.buyDepartmentCode.input,
            donatedNumber: !isNaN(Number(this.inputs.donatedNumber.input))
              ? Number(this.inputs.donatedNumber.input)
              : 0,
            donorCode: this.inputs.donorCode.input,
            budgetYear: !isNaN(Number(this.inputs.budgetYear.input))
              ? Number(this.inputs.budgetYear.input)
              : 0,
            budgetBranchCode: this.inputs.budgetBranchCode.input,
            budgetDepartmentCode: this.inputs.budgetDepartmentCode.input,
            budgetItem: this.inputs.budgetItem.input,
            equipType: this.inputs.equipType.input,
            collectionType: this.inputs.collectionType.input,
            shelfType: this.inputs.shelfType.input,
            handlingType: this.inputs.handlingType.input,
            storeType: this.inputs.storeType.input,
            storingLimitCode: this.inputs.storingLimitCode.input,
            mark: this.inputs.mark.input,
            ndc: this.inputs.ndc.input,
            book: this.inputs.book.input,
            sub: this.inputs.sub.input,
            revision: this.inputs.revision ?? 0
          }
        ]
      })

      this.updatedCallback()

      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        setErrorMessage(error.alerts, {
          autoOrders: [this.inputs]
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
